<template>
  <div v-if="selected">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Boolean, Number, String, Object, Array],
      default: null
    },

    icon: {
      type: String,
      default: ''
    },

    name: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },
  
  watch: {
    value: 'updateTab'
  },

  data () {
    return {
      selected: false
    }
  },
  
  created () {
    this.registerTab()
  },

  destroyed () {
    this.unregisterTab()
  },

  computed: {
    tab () {
      const instance = this
      const value = this.value
      const icon = this.icon
      const name = this.name
      const disabled = this.disabled

      // ES6 FTW
      return {
        instance,
        value,
        icon,
        name,
        disabled
      }
    }
  },
  
  methods: {
    valueUpdated (value) {
      this.selected = this.value === value
    },

    registerTab () {
      this.$parent.registerTab(this.tab)
    },

    unregisterTab () {
      this.$parent.unregisterTab(this.tab)
    },

    updateTab () {
      this.$parent.updateTab(this.tab)
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Tab.vue